const TeslaIcon = ({
    viewBox = "0 0 20 20",
    width,
    height,
    color = "#000",
    ...props
}) => (
  <svg
    viewBox="0 0 7853 1024"
    version="1.1"
    p-id="2548"
    width={width}
    height={height}
    {...props}
  >
    <path
      d="M0 2.128898c23.417879 89.413721 100.058212 180.956341 206.503119 204.374221h319.334719l17.031185 6.386694v808.981289h200.116424V212.889813l19.160083-6.386694h321.463618c106.444906-27.675676 183.085239-114.960499 204.37422-204.374221V0L0 2.128898zM6107.808732 1021.871102c100.058212-42.577963 153.280665-114.960499 174.569646-200.116424h-887.750519V2.128898H5194.511435v1021.871102h913.297297zM3714.927235 202.245322h702.536382c106.444906-29.804574 195.858628-112.831601 217.14761-202.245322l-1117.671518 2.128898v602.478171h913.297297v210.760914h-717.438669c-112.831601 31.933472-208.632017 106.444906-255.467776 206.503119l57.48025-2.128898h1111.284823V404.490644h-913.297297V202.245322zM6708.158004 404.490644v617.380458h197.987526V610.993763h719.567568V1021.871102h197.987526V406.619543zM1979.87526 204.37422h762.14553c106.444906-21.288981 185.214137-114.960499 206.503119-204.37422H1773.372141c21.288981 89.413721 102.18711 183.085239 206.503119 204.37422M1979.87526 608.864865h762.14553c106.444906-21.288981 185.214137-114.960499 206.503119-204.374221H1773.372141c21.288981 89.413721 102.18711 183.085239 206.503119 204.374221M1979.87526 1021.871102h762.14553c106.444906-21.288981 185.214137-114.960499 206.503119-204.374221H1773.372141c21.288981 91.54262 102.18711 185.214137 206.503119 204.374221M6884.856549 204.37422h762.14553c106.444906-21.288981 185.214137-114.960499 206.503119-204.37422h-1175.151768c21.288981 91.54262 100.058212 185.214137 206.503119 204.37422"
      fill={color}
      p-id="2549"
    ></path>
  </svg>
);


export default TeslaIcon;